import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  featherBox,
  featherCheck,
  featherChevronDown,
  featherChevronUp,
  featherX,
} from '@ng-icons/feather-icons';
import { finalize } from 'rxjs';
import { CompaniaPaqueteService } from 'src/app/api/services/company-package.service';
import { CompanyService } from 'src/app/api/services/company.service';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { MESSAGES } from 'src/app/core/constant/messages';
import { InputSelectComponent } from 'src/app/shared/component/input-select/input-select.component';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { CompaniaPaquete, Paquete } from 'src/app/shared/model/package';
import { SolesCurrencyPipe } from 'src/app/shared/pipe/soles-currency.pipe';
import { ToastService } from 'src/app/shared/service/toast.service';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-pricing',
  imports: [
    CommonModule,
    NgIcon,
    SolesCurrencyPipe,
    LoadingComponent,
    ReactiveFormsModule,
    FormsModule,
    InputSelectComponent,
    LoadingButtonComponent,
  ],
  templateUrl: './pricing.component.html',
  viewProviders: provideIcons({
    featherCheck,
    featherBox,
    featherX,
    featherChevronUp,
    featherChevronDown,
  }),
})
export class PricingComponent implements OnInit {
  packages: Paquete[] = [];
  companies: any[] = [];
  companyControl = new FormControl(null);
  selectedPackageId: string | null = null;

  isLoading: boolean = false;
  showModal: boolean = false;
  isLoadingPackage: boolean = false;

  constructor(
    private cpService: CompaniaPaqueteService,
    private tokenService: TokenStorageService,
    private companyService: CompanyService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    const auth = this.tokenService.getAuth();
    if (auth) this.loadMyCompanies();
    this.loadAllPackages();
  }

  loadMyCompanies() {
    this.companyService.getCompaniesByUserId().subscribe({
      next: (res) => {
        this.companies = res.dto.companys.map((item: any) => ({
          value: item.idCompany,
          label: item.commercialName,
        }));
      },
    });
  }

  loadAllPackages() {
    this.isLoading = true;
    this.cpService.getAllActive().subscribe((res) => {
      this.packages = res.dto.packages.map((pkg: Paquete) => ({
        ...pkg,
        igv: pkg.idPackage === APP_CONSTANTS.PACKAGE_ID_FREE ? '0' : '1',
      }));
      this.isLoading = false;
    });
  }

  openModal(pkgId: string) {
    const auth = this.tokenService.getAuth();
    if (!auth) {
      this.toastService.showMessages('warning', [MESSAGES.AUTH.UNAUTHORIZED]);
      return;
    }

    this.selectedPackageId = pkgId;

    if (this.companies.length > 0) {
      this.companyControl.setValue(this.companies[0].value);
    }

    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  acquirePackage() {
    const companyId = this.companyControl.value;

    if (!companyId) {
      this.toastService.showMessages('warning', [
        'Selecciona una compañía antes de continuar.',
      ]);
      return;
    }

    if (!this.selectedPackageId) {
      this.toastService.showMessages('error', [
        'No se ha seleccionado un paquete.',
      ]);
      return;
    }

    if (this.selectedPackageId === APP_CONSTANTS.PACKAGE_ID_FREE) {
      this.toastService.showMessages('warning', [
        'Ya tienes el paquete gratuito activo. No es necesario adquirirlo nuevamente.',
      ]);
      return;
    }

    const payload: CompaniaPaquete = {
      idCompany: companyId,
      idPackage: this.selectedPackageId,
    };
    this.isLoadingPackage = true;
    this.cpService
      .insertCompanyPackage(payload)
      .pipe(
        handleApiError(this.toastService, MESSAGES.GENERAL.ACTION_ERROR),
        finalize(() => (this.isLoadingPackage = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', ["¡Paquete solicitado con éxito!"
        ]);
        this.closeModal();
      });
  }

  getFeatureValue(pkg: Paquete, key: string): any {
    return (pkg as any)[key];
  }
}
